<template>
  <div class="box">
    <div class="is-clearfix has-margin-bottom-lg">
      <div class="is-pulled-right">
        <router-link :to="{ name: 'users-create' }"
          active-class="" exact-active-class="" class="button is-danger">
          <span class="icon"><i class="fas fa-plus"></i></span>
          <span v-t="'new_resource'" />
        </router-link>
      </div>

      <h1 class="title is-5" v-t="'title'" />
    </div>

    <users-modal :mode="form_mode" :active="form_active" />
    <users-index/>
  </div>
</template>

<script>
import UsersIndex from '@/components/UsersIndex'
import UsersModal from '@/components/UsersModal'

export default {
  name: 'Users',
  components: {
    UsersIndex,
    UsersModal
  },
  data () {
    return {
      form_mode: '', // Pode ser 'new' ou 'edit'
      form_active: false
    }
  },
  mounted () {
    this.updateForm(this.$route.name)
  },
  methods: {
    updateForm (routeName) {
      this.form_active = routeName === 'users-create' || routeName === 'users-edit'
      this.form_mode = routeName === 'users-create'
        ? 'new' : routeName === 'users-edit'
          ? 'edit' : ''
    }
  },
  watch: {
    '$route' ({ name }) {
      this.updateForm(name)
    }
  },
  metaInfo () {
    return { title: this.$t('title') }
  }
}
</script>

<i18n>
{
  "en-US": {
    "title": "Users",
    "new_resource": "New User"
  },
  "pt-BR": {
    "title": "Usuários",
    "new_resource": "Novo Usuário"
  }
}
</i18n>
